import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { GoogleAuthProvider, signInWithPopup, signInWithRedirect } from 'firebase/auth';
import { auth } from '../firebase';
import { useAuth } from '../contexts/AuthContext';

export default function Login() {
  const [error, setError] = useState(null);
  const [signingIn, setSigningIn] = useState(false);
  const location = useLocation();
  const { user, portalRole } = useAuth();

  // If already signed in with a portal role, redirect
  if (user && portalRole) {
    const from = location.state?.from?.pathname || '/';
    return <Navigate to={from} replace />;
  }

  const handleGoogleSignIn = async () => {
    setError(null);
    setSigningIn(true);
    try {
      const provider = new GoogleAuthProvider();
      // Try popup first; fall back to redirect if blocked (e.g. by COOP headers).
      try {
        await signInWithPopup(auth, provider);
      } catch (popupErr) {
        if (popupErr.code === 'auth/popup-blocked' ||
            popupErr.code === 'auth/popup-closed-by-browser') {
          await signInWithRedirect(auth, provider);
        } else {
          throw popupErr;
        }
      }
    } catch (err) {
      setError(err.message);
      setSigningIn(false);
    }
  };

  return (
    <div className="page">
      <h1>Race Officer Portal</h1>
      <p>Sign in to access the committee portal.</p>

      {user && !portalRole && (
        <div className="notice">
          You are signed in but do not have a portal role assigned.
          Contact your club administrator for access.
        </div>
      )}

      {error && <div className="error">{error}</div>}

      {!user && (
        <button
          className="btn btn-primary"
          onClick={handleGoogleSignIn}
          disabled={signingIn}
        >
          {signingIn ? 'Signing in...' : 'Sign in with Google'}
        </button>
      )}
    </div>
  );
}
